import React, { useContext, useRef } from 'react';
import classnames from 'classnames';
import get from 'lodash/get';
import Duperswiper from '../_partials/Duperswiper';
import StageBackground from '../../DeviationBackground/StageBackground';
import DeviationFullView from '../../DeviationViews/Full';
import { BiDataHook } from '../../biLogger';
import { useMeasuredStage } from '../hooks/useMeasuredStage';
import { DeviationTypes } from '../../types/deviation';
import { MatureDeviationContext } from '../../Context/MatureDeviationContext';
import { getIsShortStatus, getDeviationType, } from '../../DeviationViews/_helpers';
import HoroscopeTooltip from '../_partials/HoroscopeTooltip';
import s from './MobileArtStage.scss';
function isLandscape() {
    if (typeof window === 'undefined') {
        return false;
    }
    return get(window, 'innerHeight', 0) < get(window, 'innerWidth', 0);
}
function shouldUseFixedHeight(deviation) {
    var deviationType = getDeviationType(deviation);
    switch (deviationType) {
        case DeviationTypes.STATUS:
            return !isLandscape() && getIsShortStatus(deviation);
        case DeviationTypes.POLL:
        case DeviationTypes.IMAGE:
        case DeviationTypes.LITERATURE:
            return false;
        default:
            return true;
    }
}
var MobileArtStage = function (_a) {
    var className = _a.className, deviation = _a.deviation, isZoomed = _a.isZoomed, onEnterZoomMode = _a.onEnterZoomMode, onExitZoomMode = _a.onExitZoomMode;
    var ref = useRef(null);
    var showBlocked = useContext(MatureDeviationContext).showBlocked;
    var _b = useMeasuredStage(ref), contentSize = _b.contentSize, containerSize = _b.containerSize;
    var fixedHeight = shouldUseFixedHeight(deviation);
    return (React.createElement("div", { className: classnames(className, s['root'], fixedHeight && s['fixed-height']), "data-hook": BiDataHook.DEVIATION_ART_STAGE },
        React.createElement("div", { className: s['content'], ref: ref },
            React.createElement(Duperswiper, { key: deviation.deviationId, deviation: deviation, height: fixedHeight || showBlocked
                    ? get(containerSize, 'height')
                    : undefined, width: get(containerSize, 'width') }, function (dev) { return (React.createElement(React.Fragment, null,
                React.createElement(StageBackground, { deviation: dev }),
                React.createElement(DeviationFullView, { deviation: dev, isZoomed: isZoomed, onEnterZoomMode: onEnterZoomMode, onExitZoomMode: onExitZoomMode, height: fixedHeight || showBlocked
                        ? get(contentSize, 'height')
                        : undefined, width: get(contentSize, 'width') }),
                React.createElement(HoroscopeTooltip, { deviation: deviation, height: fixedHeight || showBlocked
                        ? get(contentSize, 'height')
                        : undefined, width: get(contentSize, 'width') }))); }))));
};
MobileArtStage.displayName = 'MobileArtStage';
export default MobileArtStage;
//# sourceMappingURL=MobileArtStage.js.map